import mutationTypes from "./mutation-types";
import getAuthService from "@/services/AuthService";

const handleError = (error: any) => {
    throw new Error(error?.response?.data?.description || error.uid || error.code);
};

const check = async ({ commit, dispatch }) => {
    try {
        const currentSession = localStorage.getItem("stqr_token");
        if (!currentSession) {
            throw new Error();
        }
        commit(mutationTypes.CHECK, currentSession);
    } catch (e) {
        dispatch("logout");
    }
};

const login = async ({ commit }, { email, password, remindsMe, accountCreated }) => {
    try {
        const sessionData = await getAuthService().login(email, password);
        commit(mutationTypes.LOGIN, { ...sessionData, remindsMe, accountCreated });
    } catch (e) {
        handleError(e);
    }
};
const activate = async ({ commit }, { id, code }) => {
    try {
        const response = await getAuthService().activate(id, code);
    } catch (error) {
        handleError(error);      
    }
};

const logout = async ({ commit }, data: { keepStorage?: boolean } = { keepStorage: false }) => {
    if (data?.keepStorage) {
        commit(mutationTypes.SOFT_LOGOUT);
    } else {
        commit(mutationTypes.LOGOUT);
    }
};

const register = async ({ commit }, { firstName, lastName, email, password }) => {
    try {
        const guest = await getAuthService().register(firstName, lastName, email, password);
        commit(mutationTypes.SET_GUEST, guest)
    } catch (e) {
        handleError(e);
    }
};

export default {
    check,
    login,
    logout,
    register,
    activate
};
